import {AxiosInstance} from 'axios';
import {addActiveFileIdInterceptor} from './activeFileIdInterceptor';
import {addBlobCoercionInterceptor} from './axiosBlobCoercionInterceptor';
import {addSessionIdInterceptor} from './sessionIdInterceptor';
import {addSpanIdInterceptor} from './spanIdInterceptor';
import {addCsrfInterceptor} from './csrfInterceptor';
import {addUnauthorizedInterceptor} from './unauthorizedInterceptor';

export function addStandardInterceptors(instance: AxiosInstance): void {
  addCsrfInterceptor(instance);
  addBlobCoercionInterceptor(instance);
  addSessionIdInterceptor(instance);
  addSpanIdInterceptor(instance);
  addActiveFileIdInterceptor(instance);
  addUnauthorizedInterceptor(instance);
}
